/* eslint-disable complexity */
import {forwardRef} from 'react';
import {useHistory} from 'react-router-dom';
import classNames from 'classnames';
import assert from 'assert';

import sdk from '@/sdk';
import * as store from '@/store';
import {feLogger, tagClickRep} from '@/buried';
import routers, {buildPath} from '@/config/routers';
import Icon from '@/components/Icon';
import {CloseTagSvg} from '@/icons';
import kuPiper from '@/middleware/kuPiper';

import {TagData} from '../interface';

import styles from './index.module.scss';

interface IProps extends TagData {
    className?: string;
    disabled?: boolean;
    docGuid?: string;
    onClickClose?: (tag: TagData) => void;
    rootId?: string;
}

const TagItem = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    const {name, className, onClickClose, disabled, tagType, tagFrom = 2, docGuid = '', rootId} = props;
    const history = useHistory();

    function onClickIcon(e: React.MouseEvent) {
        e.stopPropagation();
        onClickClose &&
            onClickClose({
                name,
                tagType,
                tagFrom,
            });
    }

    async function toTagPage() {
        try {
            const isBaikeRepo = store.getData(store.KEYS.IS_BAIKE_REPO);
            const repository = store.getCurRepository();
            assert(repository);
            const ksServer = await sdk.getKsServer(repository);
            const tagName = encodeURIComponent(isBaikeRepo ? `${rootId}·${name}` : name) || '';
            await sdk.as.recentlyEvent({
                token: 'f5engt5vrznp',
                repositoryGuid: repository.repositoryGuid || '',
                tagName,
                email: ksServer?.user?.email || '',
                userGuid: ksServer?.user?.userGuid || '',
                docGuid: docGuid,
            });

            const params = {
                spaceGuid: repository?.spaceGuid || '',
                groupGuid: repository?.groupGuid || '',
                repositoryGuid: repository?.repositoryGuid || '',
                tagName,
            };
            const url = buildPath(isBaikeRepo ? routers.baike.homeTagPath : routers.Knowledge.homeTagPath, params);
            const jumpProxy = kuPiper.runProxy(kuPiper.proxyNameMap.docTagClickJump, (url: string) => {
                history.push(url);
            });
            jumpProxy(url);
        } catch (err) {
            console.log('err: ', err);
        }
    }

    function handleClick() {
        toTagPage();
        feLogger(tagClickRep({pageId: docGuid, tagContent: name, type: tagFrom === 1 ? '1' : '0'}));
    }

    return (
        <div
            className={classNames(className, styles.wrapper)}
            ref={ref}
            onClick={handleClick}
        >
            <span>{name}</span>
            {!disabled && <Icon className={styles.close} svg={CloseTagSvg} onClick={onClickIcon} />}
        </div>
    );
});

export default TagItem;
